export enum userInteraction {
  USER_CANCELED = 'userInteractionCanceled',
}
